export enum Contract {
  Unsupported = -1,
  None = 0,
  ROMERIKE = 1,
  AIRPORTCOACH = 2,
  // BAERUM = 3, // Terminated contract - not used anymore
  OSLONORDOST = 4,
  ROGALAND = 5,
  FOLLO = 6,
  OSLOSOR = 7,
  OSTERDALEN = 12,
  BLEKINGE = 101,
}

/**
 * Applications a user can be granted access to.
 *
 * Values mirror the backend `Application` enum carried by
 * `GET /User/permissions`. A user holds at most one role per application, and
 * an application missing from the grant list means no access to it.
 */
export enum Application {
  /**
   * Sentinel for an application this frontend does not recognise. Never
   * displayed and never submitted — it only exists so an unmapped wire value
   * has a name.
   */
  Unknown = 0,

  /** Dispatcher Journal — daily operations of the bus network */
  DispatcherJournal = 1,

  /** Health Check — technical fault messages from vehicles */
  HealthCheck = 2,

  /** Difference Checker — unexpected differences in planning data */
  DifferenceChecker = 3,

  /** Washing — buses due for cleaning at the depot */
  Washing = 4,
}

/**
 * Defines the available user roles in the system
 */
export enum Role {
  /** Default role for users with no specific permissions */
  Default = -1,

  /** Local dispatcher with permissions to manage local transportation operations */
  LocalDispatcher = 1,

  /** Central dispatcher with system-wide dispatch permissions */
  CentralDispatcher = 2,

  /** Read-only access to all system features */
  GeneralReadOnly = 3,

  /** Read-only access limited to specific contract information */
  ContractReadOnly = 4,

  /** External user with limited system access */
  External = 5,

  /** Administrator role with full system access */
  SuperUser = 10,
}
